import * as React from "react"

const Spacer = ({className,...props}) => (
  <div {...props}  className={"spacer " +(className ? className : '')} ></div> 
) 
export default Spacer
